import { cn } from "../lib/utils";

export const STATUS_META = {
  todo: { label: "To Do", color: "#64748B" },
  in_progress: { label: "In Progress", color: "#3B82F6" },
  retensi: { label: "Retensi", color: "#1E3A8A" },
  review: { label: "Review", color: "#F59E0B" },
  done: { label: "Done", color: "#10B981" },
};

export const PRIORITY_META = {
  urgent: { label: "Urgent", color: "#E31E24" },
  high: { label: "High", color: "#F97316" },
  normal: { label: "Normal", color: "#3B82F6" },
  low: { label: "Low", color: "#64748B" },
};

export function StatusBadge({ status, className }) {
  const m = STATUS_META[status] || STATUS_META.todo;
  return (
    <span data-testid={`status-badge-${status}`} className={cn("inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium text-white", className)} style={{ backgroundColor: m.color }}>
      {m.label}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  const m = PRIORITY_META[priority] || PRIORITY_META.normal;
  return (
    <span data-testid={`priority-badge-${priority}`} className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium border", className)} style={{ color: m.color, borderColor: m.color, backgroundColor: `${m.color}14` }}>
      <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor"><path d="M1 7V1h1l4 2-4 2.5" /></svg>
      {m.label}
    </span>
  );
}

const AVATAR_COLORS = ["#1B2A6B", "#E31E24", "#0E7490", "#7C3AED", "#B45309", "#047857"];

export function Avatar({ name = "?", userId = "", size = "md", className, online }) {
  const initials = name.split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  const idx = [...(userId || name)].reduce((a, c) => a + c.charCodeAt(0), 0) % AVATAR_COLORS.length;
  const sz = size === "sm" ? "h-5 w-5 text-[9px]" : size === "lg" ? "h-9 w-9 text-sm" : "h-6 w-6 text-[10px]";
  return (
    <span className={cn("relative inline-flex shrink-0", className)} title={name}>
      <span data-testid={`avatar-${name.replace(/\s+/g, "-").toLowerCase()}`}
        className={cn("inline-flex items-center justify-center rounded-full text-white font-semibold", sz)}
        style={{ backgroundColor: AVATAR_COLORS[idx] }}>
        {initials}
      </span>
      {online !== undefined && (
        <span data-testid={`presence-dot-${name.replace(/\s+/g, "-").toLowerCase()}`} title={online ? "Online" : "Offline"}
          className="absolute -bottom-0.5 -right-0.5 h-2 w-2 rounded-full ring-2 ring-background"
          style={{ backgroundColor: online ? "#22C55E" : "#EF4444" }} />
      )}
    </span>
  );
}

export function ProgressBar({ value = 0, className }) {
  return (
    <div className={cn("h-1.5 w-full rounded-full bg-muted overflow-hidden", className)}>
      <div className="h-full rounded-full bg-[#10B981] transition-[width] duration-300" style={{ width: `${Math.min(100, Math.max(0, value))}%` }} />
    </div>
  );
}

export function isOverdue(task) {
  if (!task.due_date || task.status === "done") return false;
  return task.due_date < new Date().toISOString().slice(0, 10);
}
